<template>
  <section class="p-1">
    <div class="mt-6">
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Admin User</div>
            <div>
              <bread-crumb :bread-crumbs="['Add User']" />
            </div>
          </v-card-title>
          <v-divider class="p-0 m-0 primary--text"></v-divider>

          <v-card-text class="mt-5">
            <OverlayPageVue :showOverlay="loaderOverlay" />
            <v-row justify="center" class="ms-1 me-1">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">First Name</label>
                <v-text-field
                  placeholder="First Name"
                  class="rounded height"
                  :rules="first_nameRules"
                  required
                  outlined
                  v-model="basicDetails.first_name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize">Middle Name</label>
                <v-text-field
                  placeholder="Middle Name"
                  class="rounded"
                  outlined
                  dense
                  v-model="basicDetails.middle_name"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Last Name</label>
                <v-text-field
                  placeholder="Last Name"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="last_nameRules"
                  v-model="basicDetails.last_name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" class="ms-1 me-1 mt-1" xs="6">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required">Mobile Number</label>
                <v-text-field
                  placeholder="Mobile Number"
                  class="rounded"
                  prefix="+60"
                  type="number"
                  hide-spin-buttons
                  :hint="'+60 xx xxx xxxx'"
                  required
                  outlined
                  dense
                  :rules="contactNumbrules"
                  v-model="basicDetails.phone_number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Country</label>
                <v-autocomplete
                  v-model="basicDetails.country_code"
                  class="rounded"
                  :items="CountryList"
                  outlined
                  dense
                  placeholder="Country"
                  :rules="CountryRules"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Nationality</label>
                <v-autocomplete
                  :items="NationalityList"
                  class="rounded"
                  v-model="basicDetails.nationality_code"
                  outlined
                  dense
                  placeholder="Nationality"
                  :rules="nationalityRules"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="ms-1 me-1 mt-1">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">
                  Email
                  <i style="font-size: 10px">(User Id)</i></label
                >
                <v-text-field
                  placeholder="Email"
                  class="rounded"
                  required
                  outlined
                  dense
                  :disabled="$route.query.login_id"
                  v-model="basicDetails.email"
                  :rules="emailRules"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Designaton</label>
                <v-text-field
                  placeholder="Designaton"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="designationRules"
                  v-model="basicDetails.designation"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Department</label>
                <v-text-field
                  placeholder="Department"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="departmentRules"
                  v-model="basicDetails.department"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="ms-1 me-1 mt-1">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Assign Roles</label>
                <v-autocomplete
                  :items="assignedRoles"
                  :rules="assignedRules"
                  dense
                  outlined
                  v-model="basicDetails.role_code"
                  class="rounded"
                  placeholder="Assign Roles"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize">Staff ID</label>
                <v-text-field
                  dense
                  outlined
                  v-model="basicDetails.staff_id"
                  class="rounded"
                  placeholder="Staff ID"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="my-0 labelFontsize required"
                  >Lock if not login
                  <i style="font-size: 10px">(days,if not logged in.)</i></label
                >
                <v-text-field
                  placeholder="Lock if not login"
                  class="rounded"
                  required
                  outlined
                  dense
                  :rules="lockifnotrules"
                  v-model="basicDetails.lock_if_not_login"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row justify="start" class="ms-1 me-1 mt-1" xs="6">
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize"
                  >Date Limited
                  <i style="font-size: 10px"
                    >(Blank or '0' mean Unlimited Date)</i
                  >
                </label>
                <v-text-field
                  v-model="basicDetails.date_limited"
                  class="rounded"
                  outlined
                  type="date"
                  dense
                  placeholder="Date Limited"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required">Address</label>
                <v-text-field
                  class="rounded"
                  v-model="basicDetails.address"
                  outlined
                  dense
                  placeholder="Address"
                  :rules="addressRule"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 labelFontsize required"
                  >Main Channel Partner</label
                >
                <v-autocomplete
                  dense
                  outlined
                  multiple
                  :search-input.sync="searchInput"
                  @change="searchInput = ''"
                  :items="sending_partner_partners"
                  :rules="FieldRequired('Channel Partner Country')"
                  v-model="basicDetails.partner_list"
                  class="rounded"
                  placeholder="Channel Partner Country"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <div class="row">
              <div
                class="col-md-12"
                style="display: flex; justify-content: end"
              >
                <v-btn
                  depressed
                  small
                  color="primary"
                  class="mb-10 me-2 text-capitalize"
                  @click="onSubmitFor()"
                >
                  {{ $route.query.login_id ? "Update" : "Add" }}
                </v-btn>

                <v-btn
                  depressed
                  small
                  color="primary"
                  class="me-4 mb-10 text-capitalize"
                  outlined
                  @click="cancel()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-form>
    </div>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>
<script>
import { FieldRequired } from "@/utils/validation.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import Loading from "vue-loading-overlay";
import { validation } from "@/utils/validationCopy.js";
import { checkNumber, mapMobilenumb } from "@/utils/contactNumber/formatNumber";
import userService from "@/services/UserService/userService.js";
import commonService from "@/services/CommonService/commonService.js";
export default {
  mixins: [alerts],
  name: "Add User",
  data: () => ({
    FieldRequired,
    ...validation,
    checkNumber,
    searchInput: "",
    mapMobilenumb,
    NationalityList: [],
    assignedRoles: [],
    CountryList: [],
    sending_partner_partners: [],
    loader: false,
    valid: true,
    loaderOverlay: false,
    basicDetails: {
      first_name: "",
      middle_name: "",
      last_name: "",
      phone_number: "",
      country_code: "",
      nationality_code: "",
      email: "",
      designation: "",
      department: "",
      role_code: "",
      staff_id: "",
      is_partner_user: false,
      date_limited: null,
      remarks: "",
      user_type: "USR",
      partner_list: [],
      address: "",
      lock_if_not_login: null,
    },
  }),

  components: {
    BreadCrumb,
    Loading,
    OverlayPageVue,
  },

  mounted() {
    this.getcountryList();
    this.getmainSenderpartner();
    this.getNationality();
    console.log("route.query.login_id  " + this.$route.query.login_id);
    this.editpage();
    this.getRolesList();
  },

  watch: {
    "basicDetails.partner_list"(val) {
      console.log("basicDetails.partner_list", val);
    },
    "$route.query.login_id": {
      immediate: true,
      handler(newVal) {
        console.log(newVal + "value");
        this.editpage();
      },
    },
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    onSubmitFor() {
      if (this.$route.query.login_id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.postList();
        // console.log('update')
      }
    },
    cancel() {
      if (this.$route.query.login_id) {
        this.$router.push({ name: "ListUser" }),
          this.$refs.complincmanual.reset();
      } else {
        console.log("else");
        this.$refs.complincmanual.reset();
        // console.log('update')
      }
    },
    oncancel() {
      if (this.$route.query.login_id) {
        this.$router.push({ name: "ListUser" });
      } else {
        this.$v.$reset();
        this.basicDetails = Object.assign({}, {});
        // console.log('update')
      }
    },

    async getNationality() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.NationalityList = response.data.data.map((i) => {
            return { text: i.nationality, value: i.iso_alpha3 };
          });
          console.log("Nationalty", this.NationalityList);
          this.stoploader();
        } else {
          this.NationalityList == [];
          this.stoploader();
        }
      } catch (error) {
        this.NationalityList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getcountryList() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.CountryList = response.data.data.map((i) => {
            return { text: i.country_name, value: i.iso_alpha3 };
          });
          console.log("CountryList", this.CountryList);
          this.stoploader();
        } else {
          this.CountryList == [];
          this.stoploader();
        }
      } catch (error) {
        this.CountryList = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getmainSenderpartner() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getmainSenderpartner();
        if (response.data.status_code === 200) {
          this.sending_partner_partners = response.data.data.map((i) => {
            return { text: i.partner_name, value: i.partner_id };
          });
          this.stoploader();
        } else {
          this.stoploader();
        }
      } catch (error) {
        this.assignedRoles = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getRolesList() {
      this.loaderOverlay = true;
      try {
        const response = await userService.getAllRoles();
        if (response.data.status_code === 200) {
          this.assignedRoles = response.data.data.map((i) => {
            return { text: i.name, value: i.role_id };
          });
          console.log("assignedRoles", this.CountryList);
          this.stoploader();
        } else {
          this.assignedRoles == [];
          this.stoploader();
        }
      } catch (error) {
        this.assignedRoles = [];
        this.stoploader();
        console.error(error);
      }
    },
    async postList() {
      const validate = this.$refs.complincmanual.validate();
      const Format_num = this.checkNumber(this.basicDetails.phone_number);
      this.basicDetails.phone_number = Format_num;
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await userService.PostadminUser(
            this.basicDetails,
          );
          if (responseData && responseData.data.status_code == 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.cancel();
            setTimeout(() => this.$router.push({ name: "List Of Users" }), 500);
          } else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.stoploader();
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },

    onupdate() {
      console.log(`basicDetails: ${JSON.stringify(this.basicDetails)}`);
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.basicDetails);
      this.update();
    },
    ClickBack() {
      this.$emit("onClickBack");
    },

    async update() {
      const Format_num = this.checkNumber(this.basicDetails.phone_number);
      this.basicDetails.phone_number = Format_num;
      const role_code = "" + this.basicDetails.role_code;
      this.basicDetails.role_code = role_code;
      this.loaderOverlay = true;
      try {
        const responseData = await userService.UpdateadminUser(
          this.$route.query.login_id,
          this.basicDetails,
        );
        if (responseData && responseData.data.status_code == 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          setTimeout(() => this.$router.push({ name: "List Of Users" }), 300);
        } else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async editpage() {
      const routerDataItem = this.$route.query.login_id;
      if (routerDataItem) {
        try {
          const response = await userService.getAdminuserbyId(routerDataItem);
          if (response.data.status_code === 200) {
            this.userList = response.data.data;
            this.basicDetails = response.data.data[0];
            this.basicDetails.role_code = parseInt(
              response.data.data[0].role_code,
            );
            // to map mobile number in text-field without error
            const Format_num = this.mapMobilenumb(
              this.basicDetails.phone_number,
            );
            this.basicDetails.phone_number = Format_num;
            this.basicDetails.partner_list =
              response.data.data[0].partner_list.map((ele) => {
                return ele.partner_id;
              });
          }
        } catch (error) {
          this.userList = [];
          this.stoploader();
          console.error(error);
        }
      } else {
        console.log("basicpartnerDetails");
        this.basicDetails = {
          first_name: "",
          middle_name: "",
          last_name: "",
          phone_number: "",
          country_code: "",
          nationality_code: "",
          email: "",
          designation: "",
          department: "",
          role_code: "",
          staff_id: "",
          is_partner_user: false,
          partner_id: "",
          branch_id: "",
          view_past_txns: null,
          date_limited: null,
          remarks: "",
          user_type: "USR",
          lock_if_not_login: null,
        };
      }
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
